<template>
  <div class="container">
    <CommonHeader
      title="现金奖励"
      :value="value"
    />
    <LongList
      :api-method="getData"
    >
      <template #default="{list}">
        <BillTable
          :data="list"
          :columns="columns"
        />
      </template>
    </LongList>
  </div>
</template>

<script>
import { formatAmount } from '@/util/filter';
import Api from '@/api/bill';
import BillTable from '@/components/BillTable';

export default {
  name: 'CashReWard',
  components: { BillTable },
  data() {
    const { amount, cutMonth } = this.$route.query;

    const columns = [
      {
        label: '活动名称',
        prop: 'agreeName',
      },
      {
        label: '金额',
        formatter: (row) => `${formatAmount(row.amount)}元`,
      },
    ];

    return {
      value: `账单金额：${formatAmount(amount)}元`,
      columns,
      cutMonth,
    };
  },
  methods: {
    getData(pageNum, pageSize) {
      const params = {
        billMonth: this.cutMonth,
        pageSize,
        pageNum,
      };
      return Api.queryBonusCashDetail(params);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 16px;
}
/deep/ .red {
  color: red;
}
</style>
